// @flow
import * as React from 'react'
import {
  Container,
  Overlay,
  Window,
  CloseButton,
  WindowWrapper,
  Title,
  Header,
  Subtitle,
} from './elements'

// Types
type Props = {
  showed?: boolean,
  children?: any,
  onClose?: ?Function,
  title?: React.Node,
  subtitle?: React.Node,
}

/**
 * The desktop lightbox component with overlay and white window
 * @param  {Object} props
 * @return {React.Element}
 */
const DesktopLightbox = ({
  showed,
  children,
  onClose,
  title,
  subtitle,
}: Props) => (
  <Container>
    <Overlay $showed={showed} onClick={onClose} />
    <WindowWrapper $showed={showed}>
      <Window>
        {!!(title || subtitle) && (
          <Header>
            {!!title && <Title>{title}</Title>}
            {!!subtitle && <Subtitle>{subtitle}</Subtitle>}
          </Header>
        )}
        {children}
      </Window>
      {onClose && <CloseButton onClick={onClose} />}
    </WindowWrapper>
  </Container>
)

export default DesktopLightbox
